import { t } from '@/locale/index.js'
import { applyColumnLabels } from '@/utils/listPageI18n.js'

export const HOME_STAT_KEYS = {
  jishouMun: 'dashboardHome.statMachinist',
  captainMun: 'dashboardHome.statCaptain',
  sheibeiMun: 'dashboardHome.statDevice',
  baoyangMun: 'dashboardHome.statMaintenance',
  teshuMun: 'dashboardHome.statSpecialTask',
  jinnegMun: 'dashboardHome.statImprove',
  userMun: 'dashboardHome.statUsers',
}

export const HOME_CHART_KEYS = [
  'dashboardHome.chartMachinist',
  'dashboardHome.chartCaptain',
  'dashboardHome.chartDevice',
  'dashboardHome.chartMaintenance',
  'dashboardHome.chartSpecialTask',
  'dashboardHome.chartImprove',
  'dashboardHome.chartUsers',
]

export const HOME_CHART_DATA_KEYS = [
  'jishouMun',
  'captainMun',
  'sheibeiMun',
  'baoyangMun',
  'teshuMun',
  'jinnegMun',
  'userMun',
]

const MAINTENANCE_TODO_COLUMNS = {
  title: 'taskSubmit.taskName',
  real_name: 'taskSpecial.publisher',
  score: 'detail.score',
  created_at: 'taskSubmit.createdAt',
}

const SPECIAL_TODO_COLUMNS = {
  real_name: 'taskSubmit.submitterName',
  username: 'taskSubmit.submitterUsername',
  created_at: 'taskSubmit.createdAt',
}

const IMPROVE_TODO_COLUMNS = {
  title: 'taskSubmit.taskName',
  real_name: 'taskSubmit.submitterName',
  score: 'detail.score',
  created_at: 'taskSubmit.createdAt',
}

const TABLE_ITEM_SPECIAL = {
  real_name: 'taskSubmit.submitterName',
  username: 'taskSubmit.submitterUsername',
  mobile: 'taskSubmit.submitterMobile',
  created_at: 'taskSubmit.createdAt',
}

const TABLE_ITEM_IMPROVE = {
  title: 'taskSubmit.taskName',
  real_name: 'taskSubmit.submitterName',
  score: 'detail.score',
  note: 'improveSubmit.reportContent',
  created_at: 'taskSubmit.createdAt',
}

export const HOME_STAT_KEY_ORDER = HOME_CHART_DATA_KEYS

export function localizeStatItems(items) {
  return (items || []).map((item) => ({
    ...item,
    title: HOME_STAT_KEYS[item.key] ? t(HOME_STAT_KEYS[item.key]) : item.title,
  }))
}

export function getChartLabels() {
  return HOME_CHART_KEYS.map((key) => t(key))
}

export function applyMaintenanceTodoColumns(columns) {
  applyColumnLabels(columns, MAINTENANCE_TODO_COLUMNS)
}

export function applySpecialTodoColumns(columns) {
  applyColumnLabels(columns, SPECIAL_TODO_COLUMNS)
}

export function applyImproveTodoColumns(columns) {
  applyColumnLabels(columns, IMPROVE_TODO_COLUMNS)
}

export function applyTableItemSpecialColumns(columns) {
  applyColumnLabels(columns, TABLE_ITEM_SPECIAL)
}

export function applyTableItemImproveColumns(columns) {
  applyColumnLabels(columns, TABLE_ITEM_IMPROVE)
}

export { t }
